/**
 * Note: 
 *  - per aprire una dialog dedicata ad uno dei seguenti componenti [source, destination, repository, serviceAccount], vedere i this.$root.$on del componente Dialogs:
 *  - all'inizio questi oggetti sono null,
 * - quando si vuole aprire la dialog dedicata, vengono popolati
 * - Se si vuole creare/modificare un oggetto, questo viene popolato/modificato dall'esterno del suo componente dedicato, per poi essere ritornato.
 */

import SelectedResourcesLayout from "../components/utils/SelectedResourcesLayout.vue";
import Navigation from "../components/utils/Navigation.vue";
import ObjectView from "../components/dialogs/view/ObjectView.vue";
import SourceView from "../components/dialogs/view/SourceView";
import { waitSeconds, prettyBytes, assignProperties, getMapWithCategoriesAndPlatformTypes } from '../utils/utilitiesmodule';
import NoDataAvailable from "../components/utils/NoDataAvailable.vue";
import { PC_MESSAGES } from '../utils/messages';
import { DefaultObjectBuilder } from "../models/DefaulfObjectBuilder";
import LastResult from "../components/utils/LastResult.vue";
import CryptoJS from 'crypto-js';
import ClientMessageView from "../components/dialogs/view/ClientMessageView.vue";
import { ClientMessage } from "../utils/objects";
import { CronHelper } from "../utils/scheduling";
export default {
    components: {
        "SelectedResourcesLayout": SelectedResourcesLayout,
        Navigation,
        SourceView,
        NoDataAvailable,
        ObjectView,
        LastResult,
        ClientMessageView
    },

    name: "Backup",
    data() {
        return {
            //BACKUP
            job: null,
            realtimeJob: {
                isRunning: "NA",
                progress: 0,
                current_operation: ""
            },
            initialJobHash: "",
            initialJobSourceHash: "",
            initialJobDestinationHash: "",
            initialJobSchedulingHash: "",
            step: 1,
            //Questi dati servono all'interno delle funzioni
            //Questi dati sono generici e servono all'interno della pagina
            pc: null,
            selectedIndex: -1,
            realtime: {},

            //Scheduling
            cronstrue: null,
            cronParser: null,
            cronOptions: CronHelper.cronOptions,

            editing: false,

            saveBackupResult: this.$ResultValue.NeverExecuted,

            cloudTypes: [],
            microsoftTypes: [],

            schedulationType: 0,
            sourcesTypesMap: null,
            destinationsTypesMap: null

        }
    },

    props: {
        idBackup: String,
        idPC: String
    },

    beforeRouteLeave(to, from, next) {

        if (//Se il job è vuoto
            this.job==null||
            //Non è stato configurato nulla
            (this.job.sources.length==0&&this.job.destinations.length==0)
        ) {
            next();
            return;
        }

        //Se il job è stato modificato
        if (this.currentJobHash==this.initialJobHash) {
            next();
            return;
        }

        var dialogID=Math.floor(100000+Math.random()*900000).toString();
        var dialogTitle=this.$t("Exit from backup?");
        var dialogContent=this.$t('The backup configuration will not be saved and all current settings will be lost. Are you sure you want to proceed?');
        let self=this;
        this.$root.$on(dialogID, async ok => {
            self.$root.$off(dialogID);
            if (ok) {
                next()
            } else {
                next(false)
            }
        });

        //Avvio la richiesta che mi risponderà con un $emit
        this.$root.openYesNoDialog(dialogID, dialogTitle, dialogContent);

    },
    beforeDestroy: function() {
        //this.$root.$emit("CLOSEALLDIALOGS");

        this.job=null;
        this.pc=null;
        this.$root.$off("socketEventConnected");
        this.$root.$off("socketEventDisconnected");
        //Avvio un timer che controlla la connessione dei pc presenti in questa pagina
        //this.$root.checkConnectionTimerAction("stop");
        //this.$root.newPage("backup", "destroy");
        //CALLBACKS - JOB
        this.$root.$off("saveBackupSource");
        this.$root.$off("saveBackupDestination");
        //CALLBACKS - OTHER
        this.$root.$off("cancel");
        this.$root.$off("realtimeEvents");
        //this.$root.$off("addBackupsToPage");


    },
    created: function() {
        this.cloudTypes=this.$root.getCloudTypes();
        this.microsoftTypes=this.$root.getMicrosoftTypes();
        this.sourcesTypesMap=getMapWithCategoriesAndPlatformTypes("forBackupSource", true);
    },
    filters: {
        prettyBytes: function(bytes, precision) {
            return prettyBytes(bytes, precision);
        },
    },
    mounted: async function() {


        //Il watch della $route nel main valorizzerà ROOMPC in $session
        for (var i=0; i<30; i++) {
            this.pc=this.$session.getRoomPC();
            if (this.pc!=null)
                break;
            await waitSeconds(0.1);
        }

        //await this.$root.startToListenPC(this.idPC);
        let self=this;
        this.$root.$on("SETPAGEPROP", (prop, receivedJob) => {
            if (prop!="job") {
                return;
            }

            assignProperties(receivedJob, self.realtimeJob)
        });
        self.cronstrue=require('cronstrue/i18n');
        self.cronParser=require('cron-parser');


        //"socketEventDisconnected" viene emesso se la connessione socket non è attiva
        this.$root.$on("socketEventDisconnected", () => {
            //self.$root.socketConnected=false;
            self.realtimeJob.isRunning="NA";
            self.realtimeJob.progress=0;
            self.realtimeJob.current_operation="";
        });

        this.$root.checkSocket();

        //CALLBACKS - JOB
        this.$root.$on("saveBackupSource", (source) => self.saveBackupSource(source));
        this.$root.$on("saveBackupDestination", (destination) => self.saveBackupDestination(destination));
        //CALLBACKS - OTHER
        this.$root.$on("cancel", () => this.reset());
        this.$root.$on("realtimeEvents", data => console.log(data));

        //JOB
        if (this.idBackup==null) {
            this.job=DefaultObjectBuilder.getBackupJob(this.idPC);
            this.initialJobHash=this.hash(this.job);

            // [GT - 23/07/2025 - messe per indicare che almeno una sezione delle proprietà di un job è stata modificata]
            if (this.job) {
                this.initialJobSourceHash=this.hash(this.job.sources);
                this.initialJobDestinationHash=this.hash(this.job.destinations);
                this.initialJobSchedulingHash=this.hash(this.job.scheduling);

            }
            self.saveBackupResult=self.$ResultValue.NeverExecuted;
            return;
        }

        self.editing=true;
        this.$api.getBackupWithID(self.idBackup).then((value) => {

            // caso in cui non trova un job imposta valori di default
            if (value==null) {
                self.job=DefaultObjectBuilder.getBackupJob(this.idPC);
                self.initialJobHash=this.hash(this.job);
                // [GT - 23/07/2025 - messe per indicare che almeno una sezione delle proprietà di un job è stata modificata]
                if (this.job) {
                    this.initialJobSourceHash=this.hash(this.job.sources);
                    this.initialJobDestinationHash=this.hash(this.job.destinations);
                    this.initialJobSchedulingHash=this.hash(this.job.scheduling);
                }
                self.saveBackupResult=self.$ResultValue.NeverExecuted;
                return;
            }

            self.job=value;
            if (this.job.sources.length==1) {
                this.destinationsTypesMap=getMapWithCategoriesAndPlatformTypes("forBackupDestination", true, this.job.sources[0].type);
            }
            //se è stato recuperato un job e appartiene al pc corrente
            if (self.job.id_computer==self.idPC) {

                self.initialJobHash=this.hash(this.job);

                // [GT - 23/07/2025 - messe per indicare che almeno una sezione delle proprietà di un job è stata modificata]
                if (this.job) {
                    this.initialJobSourceHash=this.hash(this.job.sources);
                    this.initialJobDestinationHash=this.hash(this.job.destinations);
                    this.initialJobSchedulingHash=this.hash(this.job.scheduling);
                }

                self.saveBackupResult=self.$ResultValue.NeverExecuted;

                if (self.job.id_scheduling_policy!="") {
                    self.schedulationType=1;
                } else if (self.job.scheduling.length!=0) {
                    self.schedulationType=2;
                } else {
                    self.schedulationType=0;
                }
                return;
            }

            //se il job recuperato non corrisponde al pc corrente significa che:
            // è stato aperto un job in edit sul pc A (job.id_pc==A.id)
            // è stato cambiato il pc, da a a B
            self.$router.push("/computers/computer/"+self.idPC+"/backup/")
            //self.$router.push(this.$route.path.replace(job.id, ""));

            /*self.job={
                id: null,
                id_computer: self.idPC,
                name: "",
                sources: [],
                destinations: [],
                scheduling: [],
                id_scheduling_policy: "",
                options: {},
            }; */
        });

    },

    computed: {
        activeCronOption() {
            return this.getActiveCronOption();
        },
        currentJobHash() {
            var hash=this.hash(this.job);

            if (this.initialJobHash!=hash) {
                this.saveBackupResult=this.$ResultValue.NeverExecuted;
            } else {
                //this.saveBackupResult=this.$ResultValue.NeverExecuted;//this.$ResultValue.OK;
            }
            return hash;
        },
        currentJobSourceHash() {
            var hash=this.hash(this.job.sources);

            if (this.initialJobSourceHash!=hash) {

            } else {

            }

            return hash;
        },
        currentJobDestinationHash() {
            var hash=this.hash(this.job.destinations);

            if (this.initialJobDestinationHash!=hash) {

            } else {

            }

            return hash;
            //return this.job && this.job.destinations  ? this.hash(this.job.destinations) : null;
        },
        currentJobSchedulingHash() {
            var hash=this.hash(this.job.scheduling);

            if (this.initialJobSchedulingHash!=hash) {

            } else {

            }

            return hash;
            //return this.job && this.job.scheduling  ? this.hash(this.job.scheduling) : null;
        }



    },

    methods: {

        hash(obj) {
            return CryptoJS.SHA256(JSON.stringify(obj)).toString();
        },

        convertCronTo6Fields(cronExpression) {
            let parts=cronExpression.trim().split(" ");
            if (parts.length===7) {
                parts.pop(); // Rimuove l'ultimo elemento (anno)
            }
            return parts.join(" ");
        },
        getActiveCronOption() {
            for (const key in this.cronOptions) {
                if (this.cronOptions[key].active===true) {
                    return this.$t(key); // Restituisce il nome dell'opzione attiva
                }
            }
            return null; // Nessuna opzione attiva trovata
        },

        /*********************AZIONI SORGENTI/DESTINAZIONI ***********************************/
        isEnabled_source(type) {

            /*if (this.job.sources.length!=0) {
                return false;
            }*/

            // [GT 21/07/2025 - tolto "||this.job.sources.length!=0" altrimenti in modifica diabilitava anche tipi di sorgenti istallate come Hyper-V e SqlServer]
            //if (this.job==undefined||!this.$root.connectionsStates[this.idPC]||this.job.sources.length!=0)
            if (this.job==undefined||!this.$root.connectionsStates[this.idPC])
                return false;


            return true;
        },

        showNotInstalled(type) {
            if (type==this.$ONEServiceType.Database_SQLServer&&this.pc.system_info[this.$SystemInfoType.SQL_INSTANCES_INSTALLED].info_value=="")
                return true;

            if (type==this.$ONEServiceType.HyperV&&this.pc.system_info[this.$SystemInfoType.HYPER_V_INSTALLED].info_value=="False")
                return true;
            return false;
        },

        /** [TG - 27/03/2025] 
         *  modificata per controllo se modulo backup relativo alla sorgente è attivo
         *  se non è attivo, controllo se ci sono slot liberi, in caso affermativo assegno lo slot al computer 
         *  in caso negativo rimando alla pagina per upgrade licenza o libera slot
        */
        openSource(type_or_source) {

            //Sorgente con i sottotipi
            if (typeof type_or_source=='number'&&type_or_source==this.$ONEServiceType.Microsoft)
                return;

            let self=this;

            /** "type_or_source" corrisponde a "this.$ONEServiceType" e sono gli stessi valori che troviamo nel nodo/array "enabled_backup_sources" dell'oggetto in sessione json "LICENSES" 
             * enabled_backup_sources [
                    3,  --> Hyper-V
                    4   --> ESXI
                ]
            * se nel json LICENSE-->backup-->computers[] c'è il computer corrente, vado a leggere tutti gli id delle Sorgenti di backup abilitate
            * se type_or_source, argomento di questa funzione, è compreso in "enabledBackupSources" vuol dire che posso fare configurare quel backup
            */

            const licenseData=this.$session.getLicenses();

            // Trova la licenza che contiene la sorgente richiesta
            const backupLicense=licenseData.backup.find(backupItem =>
                backupItem.enabled_backup_sources.includes(type_or_source)
            );

            // Se la licenza di login non ha questo tipo di backup
            // Se non esiste una licenza per questo tipo di backup
            if (!backupLicense) {
                var dialogID=Math.floor(100000+Math.random()*900000).toString();
                this.$root.$on(dialogID, async ok => {
                    self.$root.$off(dialogID);
                    if (!ok) {
                        return; // se utente clicca no la function si ferma qui.
                    }

                    self.$router.replace({ path: '/licenses' });

                });

                //$ONEServiceTypeInfo[sourceType].name

                this.$root.openYesNoDialog(dialogID, this.$t("License Upgrade Required"),
                    this.$t("license_not_supported", { 0: self.$ONEServiceTypeInfo[type_or_source].name }));
                return;
            }


            // Ottieni total_slots e used_slots
            const { total_slots, used_slots, computers }=backupLicense;

            // Verifica che il computer corrente sia abilitato nella licenza
            const isComputerLicensed=computers.some(computer => computer.id===self.idPC);


            //Il computer corrente è abilitato al modulo di licenza
            if (isComputerLicensed) {

                //Se si deve configurare la prima sorgente o modificare quella esistente, apro la dialog
                if (self.job.sources.length==0||typeof type_or_source=='object') {
                    this.$root.$emit("OPENSOURCEDIALOG", type_or_source);
                    return;
                }

                //Se è già stata configurata una sorgente, chiedo all'utente cosa vuole fare
                var dialogID=Math.floor(100000+Math.random()*900000).toString();
                var dialogTitle=this.$t("Backup source already configured");
                var dialogContent=this.$t("A backup source has already been configured. Would you like to replace it?");
                this.$root.$on(dialogID, async ok => {
                    self.$root.$off(dialogID);
                    if (!ok) {
                        return;
                    }

                    self.selectedIndex=-1;
                    self.$root.$emit("OPENSOURCEDIALOG", type_or_source);
                });
                this.$root.openYesNoDialog(dialogID, dialogTitle, dialogContent);
                return;
            }



            // il computer corrente non è associato a nessun modulo licenza
            // devo chiedere all'utente se vuole utilizzare uno slot, se ci sono slot liberi.

            // Controlla che ci siano slot disponibili
            if (used_slots>=total_slots) { // qui messaggio che dice che deve liberare uno slot oppure fare upgrade della licenza
                //this.$root.$emit('SHOW_MESSAGE', 'Hai esaurito gli slot disponibili per questo tipo di backup.');

                var dialogID=Math.floor(100000+Math.random()*900000).toString();
                this.$root.$on(dialogID, async ok => {
                    self.$root.$off(dialogID);
                    if (!ok) {
                        return;
                    }

                    self.$router.replace({ path: '/licenses' });

                });

                this.$root.openYesNoDialog(dialogID, this.$t("Not module associated"),
                    this.$t("upgrade_license", { 0: self.$ONEServiceTypeInfo[type_or_source].name }));
                return;
            }
            // qui messaggio per chiedere se vuole utilizzare lo slot
            // se l'utente risponde si, faccio preseguire e aggiungo il pc alla licenza con 

            var dialogID=Math.floor(100000+Math.random()*900000).toString();
            this.$root.$on(dialogID, async ok => {
                self.$root.$off(dialogID);
                if (!ok) {
                    return;
                }
                // se utente ha scelto si
                // chiamata RestAPI PUT "api/licenses/features/enable"
                //per entrambe nel body ci vuole:
                //idc : id computer
                //idf : id_feature
                self.$api.associateComputerToModule(self.idPC, backupLicense.id).then(async (value) => {
                    if (value) {
                        self.$root.toast(this.$t(PC_MESSAGES.ADD_TO_MODULE), "success")

                        let ext_lic_info=await self.$api.getLicenseExtendedInfo();

                        if (ext_lic_info!=null) {
                            this.$session.setLicenses(ext_lic_info);
                            this.licenses=this.$session.getLicenses();
                        };

                    }
                });

            });

            this.$root.openYesNoDialog(dialogID, this.$t("Computer Not Associated to Backup Module"),
                this.$t("associate_to_module", { 0: self.$ONEServiceTypeInfo[type_or_source].name }));



        },
        deleteSource(index) {
            var dialogID=Math.floor(100000+Math.random()*900000).toString();
            let self=this;
            this.$root.$on(dialogID, ok => {
                self.$root.$off(dialogID);

                if (!ok) {
                    return;
                }

                self.job.sources.clear();
                self.reset();
            });

            this.$root.openYesNoDialog(dialogID, this.$t("Delete source"), this.$t("Are you sure to delete this source?"));
        },
        openDestination(type_or_destination, index=-1) {
            let self=this;
            //destination con i sottotipi
            if (typeof type_or_destination=='number'&&type_or_destination==this.$ONEServiceType.Cloud)
                return;

            //Se si deve configurare la prima sorgente o modificare quella esistente, apro la dialog
            if (self.job.destinations.length==0||typeof type_or_destination=='object') {
                this.$root.$emit("OPENDESTINATIONDIALOG", type_or_destination);
                return;
            }

            //Se è già stata configurata una sorgente, chiedo all'utente cosa vuole fare
            var dialogID=Math.floor(100000+Math.random()*900000).toString();
            var dialogTitle=this.$t("Backup destination already configured");
            var dialogContent=this.$t("A backup destination has already been configured. Would you like to replace it?");
            this.$root.$on(dialogID, async ok => {
                self.$root.$off(dialogID);
                if (!ok) {
                    return;
                }

                self.selectedIndex=-1;
                self.$root.$emit("OPENDESTINATIONDIALOG", type_or_destination);

            });
            this.$root.openYesNoDialog(dialogID, dialogTitle, dialogContent);
        },
        deleteDestination(index) {
            var dialogID=Math.floor(100000+Math.random()*900000).toString();
            let self=this;
            this.$root.$on(dialogID, ok => {
                self.$root.$off(dialogID);

                if (!ok) {
                    return;
                }

                self.job.destinations.clear();
                self.reset();
            });

            this.$root.openYesNoDialog(dialogID, this.$t("Delete destination"), this.$t("Are you sure to delete this destination?"));
        },


        /********************************SALVATAGGIO***********************************************************************/
        //Codice predisposto solo per una sola sorgente!!
        async saveBackupSource(source) {
            this.job.sources.clear();
            await waitSeconds(0.2);
            this.job.sources.push(source);
            this.destinationsTypesMap=getMapWithCategoriesAndPlatformTypes("forBackupDestination", true, source.type)

            this.job.name=this.buildDefaultName();
            this.job.type=source.type.toString();
            this.job.id_computer=this.idPC;
            this.$root.$emit("CLOSESOURCEDIALOG");
            this.reset();

        },

        //Codice predisposto solo per una sola destinazione!!
        async saveBackupDestination(destination) {
            this.job.destinations.clear();
            await waitSeconds(0.2);

            //Per evitare loop controllo se la destinazione interferisce con la sorgente
            // Se ho selezionato come sorgente C:\Documents
            //Non posso selezionare come destinazione C:\Documents o C:\Documents\Importanti
            if (this.job.sources[0].type==destination.type) {
                var destinationPath=destination.path;
                var sourcePaths;
                if (this.job.sources[0].type==this.$ONEServiceType.FileFolder) {
                    sourcePaths=this.job.sources[0].folderSource.paths.map(n => n.path);
                }

                if (this.job.sources[0].type==this.$ONEServiceType.Network) {
                    sourcePaths=this.job.sources[0].networkSource.paths.map(n => n.path);
                }

                if (sourcePaths.some(sourcePath => destinationPath==sourcePath)) {
                    this.$root.toast(this.$t("You cannot select a path that is already included as a source item"), "alert");
                    return;
                }

                if (sourcePaths.some(sourcePath => destinationPath.startsWith(sourcePath+destination.type.getSeparator()))) {
                    this.$root.toast(this.$t("You cannot select a path that is a sub-path of a source item"), "alert");
                    return;
                }
            }

            this.job.destinations.push(destination);
            this.$root.$emit("CLOSEDESTINATIONDIALOG");
            this.reset();

        },

        openTab(index) {
            this.step=index;
        },

        async saveBackup() {
            let self=this;
            this.$root.$emit("sendClientMessage", ClientMessage.wait("Backup saving in progress"), "backupmethods");

            //Non è possibile creare cartelle con il punto alla fine e il nome del backup in alcuni casi è il nome della cartella di backup
            this.job.name = this.job.name.trimEnd(".");
            this.$root.$on("saveJob_feedback", feedback => {
                self.saveBackupResult=feedback.status;

                if (self.saveBackupResult==self.$ResultValue.OK) {
                    assignProperties(feedback.job, self.job);
                    self.initialJobHash=this.hash(self.job);

                    // [GT - 23/07/2025 - messe per indicare che almeno una sezione delle proprietà di un job è stata modificata]
                    if (self.job) {
                        self.initialJobSourceHash=this.hash(self.job.sources);
                        self.initialJobDestinationHash=this.hash(self.job.destinations);
                        self.initialJobSchedulingHash=this.hash(self.job.scheduling);
                    }

                }

                /*if (self.saveBackupResult==self.$ResultValue.OK&&isNew) {
                    var url='/computers/computer/{0}/backup/{1}'.format(self.idPC, self.job.id);
                    self.$root.$off("saveJob_feedback");
                    //self.$router.push(url);
                    self.$router.replace(url);
                    return;
                }*/
                if (self.saveBackupResult==self.$ResultValue.OK) {
                    waitSeconds(2).then(() => {
                        var url='/computers/computer/{0}#backups'.format(self.idPC);
                        self.$root.$off("saveJob_feedback");
                        //self.$router.push(url);
                        self.$router.replace(url);
                        return;
                    });
                }

                if (self.saveBackupResult!=self.$ResultValue.Running) {
                    self.$root.$off("saveJob_feedback");
                    return;
                }

            });

            this.$root.$emit("saveJob", this.job);
        },


        buildDefaultName() {
            if (this.job.id!=null) {
                return this.job.name.validateFSItem();
            }

            var source=this.job.sources[0];
            var sourceName=this.$ONEServiceTypeInfo[source.type].name;
            switch (source.type) {
                case this.$ONEServiceType.DriveImage:
                    var selectedDisks=source.driveImgSource.filter(d => d.selected||d.indeterminate);
                    //CASO 1 : Un solo disco selezionato
                    if (selectedDisks.length==1&&selectedDisks[0].selected) {
                        return (sourceName+" - "+selectedDisks[0].caption).validateFSItem();
                    }
                    //CASO 2 : un solo disco parzialmente selezionato
                    if (selectedDisks.length==1&&selectedDisks[0].indeterminate) {
                        var selectedPartitions=selectedDisks[0].partitions.filter(p => p.selected);
                        //CASO 2.1 : un solo disco parzialmente selezionato + una sola partizione selezionata
                        if (selectedPartitions.length==1) {
                            //return sourceName + " - " + selectedDisks[0].caption + " - " + selectedPartitions[0].visibleLabel
                            return (sourceName+" - "+selectedPartitions[0].visibleLabel).validateFSItem();
                        }
                    }

                    //CASO 3 : tutti gli altri casi
                    return sourceName.validateFSItem();

                case this.$ONEServiceType.HyperV:
                    var selectedVMs=source.hvSource.filter(vm => vm.selected||vm.indeterminate);
                    if (selectedVMs.length==1&&selectedVMs[0].selected) {
                        return (sourceName+" - "+selectedVMs[0].name).validateFSItem();
                    }
                    if (selectedVMs.length==1&&selectedVMs[0].indeterminate) {
                        var selectedVirtualDisks=selectedVMs[0].partitions.filter(vd => vd.selected);
                        if (selectedVirtualDisks.length==1) {
                            return (sourceName+" - "+selectedVMs[0].name+" - "+selectedVirtualDisks[0].name).validateFSItem();
                            //return sourceName + " - " + selectedVirtualDisks[0].name;
                        }
                    }

                    //CASO 3 : tutti gli altri casi
                    return sourceName.validateFSItem();

                case this.$ONEServiceType.Microsoft_ExchangeOnPremises:
                case this.$ONEServiceType.Microsoft_ExchangeOnPremisesEWS:
                case this.$ONEServiceType.Microsoft_Exchange365:
                    var selectedMailboxes=source.exchangeSource.mailboxes.filter(m => m.selected||m.indeterminate);
                    if (selectedMailboxes.length==1) {
                        return (sourceName+" - "+selectedMailboxes[0].name).validateFSItem();
                    }

                    return sourceName.validateFSItem();

                case this.$ONEServiceType.Database_SQLServer:
                    var selectedDBs=source.dbSource.databases.filter(x => x.selected);
                    if (selectedDBs.length==1) {
                        return (sourceName+" - "+source.dbSource.serverName+" - "+selectedDBs[0].name).validateFSItem();
                    }
                    return sourceName.validateFSItem();

                case this.$ONEServiceType.Network:
                    var partsOfNetworkPath=source.networkSource.paths[0].path.split("\\");
                    if (source.networkSource.paths.length==1) {
                        return (partsOfNetworkPath[2]+" - "+partsOfNetworkPath.at(-1)).validateFSItem();//Nome del pc + ultima parte
                    }
                    return partsOfNetworkPath[2].validateFSItem();

                case this.$ONEServiceType.FileFolder:
                    var partsOfPath=source.folderSource.paths[0].path.split("\\");
                    //lettera del drive + ultima parte
                    /*if (source.folderSource.paths.length==1) {
                        return (partsOfPath[0].trimEnd(":")+" - "+partsOfPath.at(-1)).validateFSItem();//ultima parte
                    }*/
                    if (source.folderSource.paths.length==1) {
                        return partsOfPath.at(-1).validateFSItem();//ultima parte
                    }

                    return sourceName.replace("/", " ").validateFSItem();

                case this.$ONEServiceType.Microsoft_OneDriveForBusiness:
                case this.$ONEServiceType.Microsoft_SharePoint:
                case this.$ONEServiceType.Microsoft_Teams:
                    var partsOfMicrosoftPath=source.folderSource.paths[0].path.split("/");
                    if (source.folderSource.paths.length==1) {
                        return partsOfMicrosoftPath.at(-1).validateFSItem();//ultima parte
                    }
                    return sourceName.validateFSItem();
            }
            return sourceName.validateFSItem();
        },

        /******************************************BOTTONI*********************************/
        runJob() {
            let self=this;
            this.$root.$on("runJob_feedback", feedback => {

                if (feedback.status==self.$ResultValue.OK) {
                    self.realtimeJob.isRunning="R";
                }


                if (feedback.status==self.$ResultValue.Error) {
                    self.realtimeJob.isRunning="NR";
                }

                if (feedback.status!=self.$ResultValue.Running) {
                    self.$root.$off("runJob_feedback");
                    return;
                }

            });

            this.$root.$emit("runJob", this.job);
        },
        pauseJob() {
            let self=this;
            this.$root.$on("pauseJob_feedback", feedback => {

                if (feedback.status==self.$ResultValue.OK) {
                    self.realtimeJob.isRunning="NR";
                }


                if (feedback.status==self.$ResultValue.Error) {
                    self.realtimeJob.isRunning="R";
                }

                if (feedback.status!=self.$ResultValue.Running) {
                    self.$root.$off("pauseJob_feedback");
                    return;
                }

            });

            this.$root.$emit("pauseJob", this.job);
        },


        editJob() {
            this.$router.push("/computers/computer/"+this.job.id_computer+"/backup/"+this.job.id);
            this.$root.$emit("CLOSEBACKUPVIEW");
        },
        /*renameJob() {
            this.$root.$emit("OPENRENAMEJOBDIALOG", this.job.id, this.job.name);
        },*/

        configureRestoreJob() {

            // let self=this;
            // this.$root.$on("restoreJob_feedback", feedback => {

            //     if (feedback.status==self.$ResultValue.OK) {
            //         //this.$root.$emit("CLOSEBACKUPVIEW");
            //     }

            //     if (feedback.status!=self.$ResultValue.Running) {
            //         self.$root.$off("restoreJob_feedback");
            //         return;
            //     }

            // });

            this.$root.$emit("configureRestoreJob", this.job);

        },


        deleteJob() {

            let self=this;
            this.$root.$on("deleteJob_feedback", feedback => {

                if (feedback.status==self.$ResultValue.OK) {
                    //this.$root.$emit("CLOSEBACKUPVIEW");
                    self.$router.push("/computers/computer/"+this.job.id_computer);

                }

                if (feedback.status!=self.$ResultValue.Running) {
                    self.$root.$off("deleteJob_feedback");
                    return;
                }

            });

            this.$root.$emit("deleteJob", this.job);

        },

        /***************************SCHEDULING************************************************/
        toggleTab(objectToActivate) {
            //li resetto tutti...
            this.cronOptions.minutes.active=false;
            this.cronOptions.hourly.active=false;
            this.cronOptions.daily.active=false;
            this.cronOptions.weekly.active=false;
            this.cronOptions.monthly.active=false;
            this.cronOptions.yearly.active=false;
            //attivo quello selezionato
            objectToActivate.active=!objectToActivate.active;

        },

        setWizardStep(step) {
            if (step>0&&step<=4) {
                if (step==2&&this.job.sources.length==0) {
                    if (this.step==1) step=3;
                    if (this.step==3) step=1;
                }
                if (step==4&&(this.job.sources.length==0||this.job.destinations.length==0)) {
                    return;
                }

                this.step=step;
                $("#wizardTabs").data("tabs").open(step);
            }
        },

        convertToCronParserFormat(cronExpression) {
            // Dividi la stringa cron in campi
            const cronParts=cronExpression.split(' ');

            // Se la stringa ha 7 campi, rimuoviamo il primo campo (secondi)
            if (cronParts.length===7) {
                cronParts.shift(); // Rimuove il campo dei secondi
            }

            // Gestione dei campi non necessari (es: '?', '1/1') e conversione a 5 campi
            return cronParts
                .map((part, index) => {
                    // Rimuove '?' che non è supportato da cron-parser
                    if (part==='?') return '*';

                    // Rimuove '1/1' dai campi mese/giorno del mese
                    if (index>=2&&(part==='1/1'||part==='1')) return '*';
                    return part;
                })
                .slice(0, 5) // Assicuriamo che ci siano solo 5 campi
                .join(' ');
        },



        removeSched(index) {
            this.job.scheduling.splice(index, 1);


        },

        async refreshSched() {

            var self=this;
            var stringpath=CronHelper.fromOptionsToStringRest(this.cronOptions);
            //console.log(stringpath);
            var newSched=CronHelper.fromStringRestToString("/"+stringpath);
            //console.log(newSched);
            if (newSched!=null) {
                self.job.scheduling.push(newSched);
                self.job.id_scheduling_policy=""; //Ripulisco l'eventuale policy impostata
                self.nextSched(newSched);
            }
        },

        nextSched(schedString) {
            var parser=require('cron-parser');
            try {
                var compatibleString=this.convertToCronParserFormat(schedString)

                var options={
                    tz: this.$i18n.locale
                };

                var interval=parser.parseExpression(compatibleString, options);


            } catch (err) {
                console.writeError('Error: '+err.message);
            }
        },


        /***************************AZIONI ATOMICHE*************************************************/
        buildSourceTitle(sourceType) {
            if (sourceType==this.$ONEServiceType.Database_SQLServer)
                return this.$t("SQL Server is not installed in this device");

            if (sourceType==this.$ONEServiceType.HyperV)
                return this.$t("Hyper-V is not installed in this device");

            return "";
        },
        reset() {
            this.selectedIndex=-1;
            this.$root.$emit("closeFileSystemSidebar");
        },

        takeDestType(d) {
            var sourceType=this.job.sources[0].type
            var sourceInfo=this.$ONEServiceTypeInfo[sourceType];
            var destInfo=this.$ONEServiceTypeInfo[d];

            return destInfo.forBackupDestination&&sourceInfo.backupDestinationTypes.includes(d);
        }
    }
}